<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        지오펜스정보
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col">
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        기본주소
                    </label>
                    <div class="col-md-9 position-relative">
                        <input type="text" class="form-control form-control-sm"
                            formControlName="baseAddr">
                    </div>
                    <div class="col-md-9 offset-md-3 small mt-1">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="clickOpenModalAddrSearch()"
                            [disabled]="dtgActionType === DtgActionType.read">
                            <i class="mdi mdi-magnify"></i>
                            <span class="ml-1">주소검색</span>
                        </button>
                        <div>
                            주소로 대략적인 위치를 찾은 후 상세 지점으로 이동하여 설정하세요<br>
                            도형 그리기를 완료하면 중심 지점의 주소로 자동 변경됩니다
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        설정이름
                    </label>
                    <div class="col-md-9 position-relative">
                        <input type="text" class="form-control form-control-sm"
                            formControlName="geoFenceNm"
                            [ngClass]="{'is-invalid':submitted && f.geoFenceNm.errors}"
                            required
                            ngbAutofocus>
                        <div class="invalid-tooltip" *ngIf="submitted && f.geoFenceNm.errors">
                            <div *ngIf="f.geoFenceNm.errors.required">필수 입력 항목 입니다</div>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        그룹이름
                    </label>
                    <div class="col-md-9 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="dtgTeamId">
                            <option [ngValue]="null">미설정</option>
                            <option *ngFor="let item of listTeam;"
                                [ngValue]="item.dtgTeamId">
                                {{item.dtgTeamNm}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        설정형태
                    </label>
                    <div class="col-md-9 position-relative">
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="shapeType-C"
                                formControlName="shapeType"
                                (ngModelChange)="changeShapeType($event)"
                                value="C">
                            <label class="form-check-label" for="shapeType-C">원형</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="shapeType-R"
                                formControlName="shapeType"
                                (ngModelChange)="changeShapeType($event)"
                                value="R">
                            <label class="form-check-label" for="shapeType-R">사각형</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="shapeType-P"
                                formControlName="shapeType"
                                (ngModelChange)="changeShapeType($event)"
                                value="P">
                            <label class="form-check-label" for="shapeType-P">다각형</label>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                        운영형태
                    </label>
                    <div class="col-md-9 position-relative">
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="routeType-X"
                                formControlName="routeType"
                                (ngModelChange)="changeRouteType($event)"
                                value="X">
                            <label class="form-check-label" for="routeType-X">일반</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="routeType-C"
                                formControlName="routeType"
                                (ngModelChange)="changeRouteType($event)"
                                value="C">
                            <label class="form-check-label" for="routeType-C">차고지</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" class="form-check-input"
                                id="routeType-P"
                                formControlName="routeType"
                                (ngModelChange)="changeRouteType($event)"
                                value="P">
                            <label class="form-check-label" for="routeType-P">경유지</label>
                        </div>
                    </div>
                </div> -->

                <div class="form-group row align-items-center mb-0">
                    <label class="col-md-3 mb-0">
                        사용여부
                    </label>
                    <div class="col-md-9 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="useYn">
                            <option [ngValue]="'Y'">사용</option>
                            <option [ngValue]="'N'">미사용</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-auto d-flex" style="width:60vw;height:70vh;">
            <div class="flex-grow-1 h-100">
                <div id="map-container-01" class="overflow-hidden"
                    style="width:100%;height:100%;position:relative;"></div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
